export default __webpack_public_path__ + "static/media/logo.f7ab0017.svg";